

import React from "react";

export default function CardDetails(props:any) {
  let credential = props.credential.credential;

  return (
  
    <div className="details-card" style={{ backgroundImage: `url(../../img/card_no-icon_pink.svg)` }}>
        <div className="container">
            <p className="item subtitle">{props.credential.credential_type}</p>
            <p className="item title">
                {credential.credential_title ===
                "MyNextID Email Credential (Self)" ? (
                    <strong>{props.userEmail}</strong>
                ) : (
                    <strong>{credential.credentialIdentifier}</strong>
                )}
            </p>

            <div className="item">
                <p>Version: {props.credential.version}</p>
                {/* <p className="item">Issuer: {credential.issuer_title}</p> */ }

                {/* {credential.expires_in ? (
                    <p>Expires: {credential.expires_in.split(" ")[0]}</p>
                ) : (
                    credential.issued_at && (
                    <p>Valid from: {credential.issued_at.split(" ")[0]}</p>
                    )
                )} */  }

                
                {credential.valid_from && <p>Valid from: {credential.validFrom.split("T")[0]}</p>}
                {!credential.valid_from && <p>Expires: {credential.expirationDate.split("T")[0]}</p>}
            </div>
        </div>
    </div>
  );
}